export class UsersRequest {
    userIds : number[];

    constructor() {
        this.userIds = [];
    }
}